type PreserveObject = Record<string, unknown>;

export function parsePreserveJson<T>(json: unknown): T {
  if (json === null || typeof json !== 'object') {
    return json as T
  }

  var idMap = new Map<string, PreserveObject>()
  var resolved = new Map<string, unknown>()

  indexIds(json, idMap)

  return resolveValue(json, idMap, resolved) as T
}

function indexIds(value: unknown, idMap: Map<string, PreserveObject>) {
  if (value === null || typeof value !== 'object') {
    return
  }
  if (Array.isArray(value)) {
    value.forEach((item) => indexIds(item, idMap))
    return
  }
  var obj = value as PreserveObject
  if (typeof obj.$id === 'string') {
    idMap.set(obj.$id, obj)
  }
  for (var key of Object.keys(obj)) {
    if (key === '$id' || key === '$ref') {
      continue
    }
    indexIds(obj[key], idMap)
  }
}

function resolveValue(
  value: unknown,
  idMap: Map<string, PreserveObject>,
  resolved: Map<string, unknown>,
): unknown {
  if (value === null || typeof value !== 'object') {
    return value
  }
  if (Array.isArray(value)) {
    return value.map((item) => resolveValue(item, idMap, resolved))
  }
  var obj = value as PreserveObject
  if (typeof obj.$ref === 'string') {
    var refId = obj.$ref
    if (resolved.has(refId)) {
      return resolved.get(refId)
    }
    var refTarget = idMap.get(refId)
    if (!refTarget) {
      return null
    }
    return resolveObject(refTarget, idMap, resolved)
  }
  if (Array.isArray(obj.$values)) {
    return (obj.$values as unknown[]).map((item) => resolveValue(item, idMap, resolved))
  }
  return resolveObject(obj, idMap, resolved)
}

function resolveObject(
  obj: PreserveObject,
  idMap: Map<string, PreserveObject>,
  resolved: Map<string, unknown>,
): unknown {
  if (typeof obj.$id === 'string' && resolved.has(obj.$id)) {
    return resolved.get(obj.$id)
  }
  var result: PreserveObject = {}
  if (typeof obj.$id === 'string') {
    resolved.set(obj.$id, result)
  }
  for (var [key, val] of Object.entries(obj)) {
    if (key === '$id') {
      continue
    }
    result[key] = resolveValue(val, idMap, resolved)
  }
  return result
}
